<template>
  <v-dialog  persistent v-model="registerDialog">
    <v-btn accent slot="activator" class="primary">
      {{userIsRegistered ? 'Unregister' : 'Register'}}
    </v-btn>
    <v-card>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title v-if="userIsRegistered">Unregister from Meetup?</v-card-title>
            <v-card-title v-else>Register For Meetup?</v-card-title>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-text>You can always change your decision later on.</v-card-text>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-actions>
              <v-btn class="red--text darken-1" flat @click.native="registerDialog = false">Cancel</v-btn>
              <v-btn class="green--text darken-1" flat @click.native="onAgree">Confirm</v-btn>
            </v-card-actions>
          </v-flex>
        </v-layout>

      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
  export default{
    props:['meetupId'],
    data(){
      return {
        registerDialog:false,

      }
    },
    methods:{
      onAgree(){
       if(this.userIsRegistered){
         this.$store.dispatch('unRegisterUserFromMeetup',this.meetupId);
       }else{
         this.$store.dispatch('registerUserForMeetup',this.meetupId);
       }
      }
    },
    computed:{
      userIsRegistered(){
        return this.$store.getters.user.registeredMeetups.findIndex(meetupId =>{
          return meetupId === this.meetupId;
        }) >= 0;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Meetup/Registration/RegistrationDialog.vue